import type { TextFieldProps } from '@mui/material';

interface SearchFieldProps {
  placeholder: string;
  currentResultLength?: number;
  disableSearch?: boolean;
  disableGutters?: boolean;
  name: string;
  typingSearch?: boolean;
}

enum KeyboardEvents {
  ENTER = 'Enter',
}

type StyledTextFieldProps = TextFieldProps & {
  disableGutters?: boolean;
};

export { type SearchFieldProps, KeyboardEvents, type StyledTextFieldProps };
